import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { ButtonGroupModule } from '@shared-ui-lib/button-group/button-group.module'
import { ButtonModule } from '@shared-ui-lib/button/button.module'
import { TranslationModule } from '@localization-lib/language/translation.module'

@Component({
    standalone: true,
    imports: [ButtonGroupModule, ButtonModule, TranslationModule],
    selector: 'app-landing-page-go-to-register',
    templateUrl: './landing-page-go-to-register.component.html',
    styleUrls: ['./landing-page-go-to-register.component.scss'],
})
export class LandingPageGoToRegisterComponent {
    constructor(private router: Router) {}

    goToRegister() {
        this.router.navigate(['/sign-up'])
    }

    goToDemo() {
        this.router.navigate(['/demo-request'])
    }
}
